import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import LoginForm from 'components/Credit24/LoanApplication/AuthenticationAU/LoginForm';

const propTypes = {
  authentication: PropTypes.object.isRequired,
  toggleRecoveryPasswordScreen: PropTypes.func.isRequired,
};

const LoginAU = ({ authentication, toggleRecoveryPasswordScreen }) => (
  <>
    <header className="homepage__header">
      <div className="container">
        <h1 className="homepage__title">
          <FormattedMessage id="selfservice.login.title" />
        </h1>
      </div>
    </header>
    <div className="homepage__container homepage__container--no-tabs">
      <div className="container container--mobile-fullWidth">
        <div className="homepage__content">
          <div className="content-block">
            <div className="grid">
              <div className="grid__item three-fifths palm-one-whole">
                <LoginForm
                  authentication={authentication}
                  toggleRecoveryPasswordScreen={toggleRecoveryPasswordScreen}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

LoginAU.propTypes = propTypes;

export default LoginAU;
